






import Vue from 'vue'
import CalendarEventEditorEmployeeSelect from '@/components/planning/calendar-event/employee/CalendarEventEditorEmployeeSelect.vue'
import { EmployeeEvent } from '@/model/planning/EmployeeEvent'

export default Vue.extend({
  name: 'CalendarEventEditorEmployee',

  components: {
    CalendarEventEditorEmployeeSelect
  },

  props: {
    step: String,
    editCalendarEvent: Object as () => EmployeeEvent | undefined,
  },

})
